import type { FormInstance } from 'antd'
import type { RuleObject } from 'antd/es/form'

export const validateNotificationRecipients = (
  form: FormInstance,
  t: (key: string) => string
) => {
  return async (_: RuleObject, value: string[]) => {
    const enableNotificationsValue = form.getFieldValue('enableNotifications')
    if (enableNotificationsValue && (!value || value.length === 0)) {
      throw new Error(t('SELECT_AT_LEAST_ONE_TEAM_MEMBER'))
    }
  }
}

export const validateAtLeastOneWarning = (
  form: FormInstance,
  t: (key: string) => string
) => {
  return async (_: RuleObject) => {
    const enableNotificationsValue = form.getFieldValue('enableNotifications')
    if (enableNotificationsValue) {
      const notYetClockedInNotification = form.getFieldValue(
        'notYetClockedInNotification'
      )
      const missedNotification = form.getFieldValue('missedNotification')
      const clockInEarlyNotification = form.getFieldValue(
        'clockInEarlyNotification'
      )
      const clockInLateNotification = form.getFieldValue(
        'clockInLateNotification'
      )
      const clockOutEarlyNotification = form.getFieldValue(
        'clockOutEarlyNotification'
      )
      const clockOutLateNotification = form.getFieldValue(
        'clockOutLateNotification'
      )
      const durationMismatchedNotification = form.getFieldValue(
        'durationMismatchedNotification'
      )

      const hasAtLeastOneSelected =
        notYetClockedInNotification ||
        missedNotification ||
        clockInEarlyNotification ||
        clockInLateNotification ||
        clockOutEarlyNotification ||
        clockOutLateNotification ||
        durationMismatchedNotification

      if (!hasAtLeastOneSelected) {
        throw new Error(t('SELECT_AT_LEAST_ONE_WARNING'))
      }
    }
  }
}
